import * as Sentry from "@sentry/browser";

export const initSentry = () => {
    if (import.meta.env.DEV || !import.meta.env.VITE_SENTRY_DSN) {
        return;
    }
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
    });
};
